import type { ParametrosClienteFiel } from "../../../services/configuracaoDeliveryFornecedor"

export type ParametrosClienteFielModel = ParametrosClienteFiel

export const ParametrosClienteFielInicial: ParametrosClienteFielModel = {
    calculoEntrega: 0,
    tipoRedirecionamento: 0,
    tipoImpressao: 0,
    impressaoAutomatica: true,
    avisoImpressao: null,
    aceitarPedidoAutomatico: false,
    tipoPedidoMesa: 0,
    tipoPontuacao: 1,
    valorPorSelo: null,
    tipoPremio: -1,
    valorPremio: null,
    valorPremioPercentual: null,
    valorPremioPercentualMedia: null,
    valorConsumoMinimoParaSelo: null,
    fatorMultiplicadorSelos: 1,
    destinatarioAvaliacao: null,
    destinatarioFaturas: null,
    destinatarioPedidos: null,
    tipoEnvioNovaSenha: 1,
    taxaEntregaPadrao: null,
    scriptInicial: null,
    abaPadraoTelaFidelidade: 0,
    ocultarConfiguracoesEspecificas: 0,
    exigirFacebookEndUnicoParaDesconto: false,
    permitirPagamentoOnlineRetirada: false,
    exigirValidacaoTelefonePagamentoOnline: false,
    solicitarComanda: false,
    somarQtdItens: false,
    fazerZoomExibicaoFoto: false,
    adicionarItensNaTelaInicial: false,
    novaTela: false,
    recuperacaoCarrinho: false,
    mostrarTelefoneSite: false,
    podeSolicitarSaque: false,
    possuiControleEstoque: false,
    telaOtimizadaCardapio: false,
    grupoOpcaoCondicional: false,
    verificarEnderecoAtendidoPedido: true,
    recalcularPedido: false,
    validarGrupoOpcao: false,
    verificarCardapioAoFinalizarPedido: false,
    permitirEntregadorAtualizarStatusPedido: false,
    validarEnderecoListaBloqueio: false,
    buscaPedidosOtimizada: false,
    manterEnderecoCliente: true,
    latitude: null,
    longitude: null,
}

export type CampoBooleanCF = {
    campo: keyof Pick<
        ParametrosClienteFielModel,
        | "exigirFacebookEndUnicoParaDesconto"
        | "aceitarPedidoAutomatico"
        | "impressaoAutomatica"
        | "permitirPagamentoOnlineRetirada"
        | "exigirValidacaoTelefonePagamentoOnline"
        | "solicitarComanda"
        | "somarQtdItens"
        | "fazerZoomExibicaoFoto"
        | "adicionarItensNaTelaInicial"
        | "novaTela"
        | "recuperacaoCarrinho"
        | "mostrarTelefoneSite"
        | "podeSolicitarSaque"
        | "possuiControleEstoque"
        | "telaOtimizadaCardapio"
        | "grupoOpcaoCondicional"
        | "verificarEnderecoAtendidoPedido"
        | "recalcularPedido"
        | "validarGrupoOpcao"
        | "verificarCardapioAoFinalizarPedido"
        | "permitirEntregadorAtualizarStatusPedido"
        | "validarEnderecoListaBloqueio"
        | "buscaPedidosOtimizada"
        | "manterEnderecoCliente"
    >
    label: string
    descricao?: string
}

export type GrupoCheckboxesCF = { titulo: string; campos: CampoBooleanCF[] }

export const GRUPOS_CHECKBOXES_CF: GrupoCheckboxesCF[] = [
    {
        titulo: "Pedidos",
        campos: [
            {
                campo: "aceitarPedidoAutomatico",
                label: "Aceitar os pedidos automaticamente (mesmo sem impressão)",
            },
            {
                campo: "impressaoAutomatica",
                label: "Aceite automático dos pedidos a partir da impressão",
                descricao:
                    "Desabilitar apenas se o cliente usar o sistema antigo e não quiser impressão automática.",
            },
            {
                campo: "verificarEnderecoAtendidoPedido",
                label: "Verificar ao enviar pedido se endereço é atendido",
                descricao:
                    "Define se ao enviar um pedido o endereço será novamente conferido se é atendido. O endereço já foi verificado pelo app no momento de abrir o cardápio. É uma verificação de segurança dupla.",
            },
            {
                campo: "recalcularPedido",
                label: "Recalcular taxas do pedido ao enviar",
                descricao:
                    "Define se as taxas de entrega e desconto serão recalculados ao enviar um pedido. É uma trava de segurança porque o app faz este cálculo antes do envio.",
            },
            {
                campo: "validarGrupoOpcao",
                label: "Validar Grupo Opção dos pedidos",
                descricao: "Valida a quantidade definida nos grupos de opção.",
            },
            {
                campo: "verificarCardapioAoFinalizarPedido",
                label: "Verificar cardápio antes de enviar o pedido",
                descricao:
                    "Define se haverá conferência no cardápio antes de finalizar o pedido para evitar pedido com produto/adicional desativado.",
            },
            {
                campo: "grupoOpcaoCondicional",
                label: "Permitir exibição de grupos de opções condicionado ao adicional",
            },
            {
                campo: "validarEnderecoListaBloqueio",
                label: "Validar endereço (lista de bloqueio)",
                descricao: "Valida endereço ao receber pedidos.",
            },
        ],
    },
    {
        titulo: "Pagamento",
        campos: [
            {
                campo: "permitirPagamentoOnlineRetirada",
                label: "Permitir pagamento online para retirada no balcão",
            },
            {
                campo: "exigirValidacaoTelefonePagamentoOnline",
                label: "Exigir validação do telefone para pagamento online",
            },
            {
                campo: "podeSolicitarSaque",
                label: "Fornecedor pode sacar dinheiro IUGU",
            },
            {
                campo: "exigirFacebookEndUnicoParaDesconto",
                label: "Exigir cadastro via Facebook para desconto automático",
            },
        ],
    },
    {
        titulo: "Site / Cardápio",
        campos: [
            {
                campo: "somarQtdItens",
                label: "Exibir Qtd de Itens no botão para fechar pedido do site",
            },
            {
                campo: "fazerZoomExibicaoFoto",
                label: "Fazer Zoom automático da foto nos cardápios em Grid",
            },
            {
                campo: "adicionarItensNaTelaInicial",
                label: "Permitir adicionar itens na tela inicial por comandos (+) e (-)",
            },
            {
                campo: "novaTela",
                label: "Nova tela de pedidos",
            },
            {
                campo: "recuperacaoCarrinho",
                label: "Ativar Recuperação de Carrinho",
            },
            {
                campo: "mostrarTelefoneSite",
                label: "Mostrar Telefone no Button Label do site",
            },
            {
                campo: "telaOtimizadaCardapio",
                label: "Utilizar tela otimizada para o cardápio",
                descricao: "Se o cardápio tiver muitos itens a nova tela tem uma busca otimizada.",
            },
            {
                campo: "buscaPedidosOtimizada",
                label: "Busca de pedidos otimizada",
                descricao: "Buscar pedidos de forma otimizada.",
            },
        ],
    },
    {
        titulo: "Mesa e Entregador",
        campos: [
            {
                campo: "solicitarComanda",
                label: "Solicitar QrCode da comanda nos pedidos de mesa",
            },
            {
                campo: "permitirEntregadorAtualizarStatusPedido",
                label: "Permitir que o entregador atualize o status do pedido para entregue",
                descricao:
                    "Permite que quando o entregador for associado a uma entrega ele receba um link para atualizar o status do pedido para entregue.",
            },
        ],
    },
    {
        titulo: "Clientes",
        campos: [
            {
                campo: "manterEnderecoCliente",
                label: "Manter endereço dos clientes cadastrados",
                descricao: "Manter endereço dos clientes para ser usado no próximo pedido.",
            },
            {
                campo: "possuiControleEstoque",
                label: "Controle de Estoque",
            },
        ],
    },
]
